// status.ts - Single source of truth for application statuses
// NOTE: These values must match the backend ApplicationStatusV2 enum
export const STATUS = {
  APPLIED: "applied",
  VIEWED: "viewed", 
  INTERVIEW_REQUESTED: "interview_requested",
  INTERVIEW_SCHEDULED: "interview_planned", // Backend uses 'interview_planned', not 'interview_scheduled'
  OFFER: "offer",
  REJECTED: "rejected",
  HIRED: "hired"
} as const;

// Normalize any backend variants to our 6 canonical statuses
export function normalizeStatus(s: string): typeof STATUS[keyof typeof STATUS] {
  const v = String(s).toLowerCase().trim();
  
  // Applied variations
  if (v === "applied" || v === "submitted" || v === "new") return STATUS.APPLIED;
  
  // Viewed/Under Review variations  
  if (v === "viewed" || v === "under_review" || v === "reviewed") return STATUS.VIEWED;
  
  // Interview Requested variations
  if (v === "interview_requested" || v === "shortlisted") return STATUS.INTERVIEW_REQUESTED;
  
  // Interview Scheduled variations
  if (v === "interview_scheduled" || v === "interview_planned" || v === "scheduled" || v === "confirmed") return STATUS.INTERVIEW_SCHEDULED;
  
  // Offer variations
  if (v === "offer" || v === "offer_extended") return STATUS.OFFER;
  
  // Rejected variations
  if (v === "rejected" || v === "not_selected") return STATUS.REJECTED;
  
  // Hired variations
  if (v === "hired" || v === "accepted" || v === "offer_made" || v === "offer_accepted") return STATUS.HIRED;
  
  // Default fallback
  return STATUS.APPLIED;
}

// Company-side lane labels
export const COMPANY_LANES = {
  [STATUS.APPLIED]: "New Applications",
  [STATUS.VIEWED]: "Reviewed",
  [STATUS.INTERVIEW_REQUESTED]: "Interview requested", 
  [STATUS.INTERVIEW_SCHEDULED]: "Interview scheduled",
  [STATUS.OFFER]: "Offer",
  [STATUS.REJECTED]: "Not a Match",
  [STATUS.HIRED]: "Hired"
} as const;

// Candidate-side lane labels  
export const CANDIDATE_LANES = {
  [STATUS.APPLIED]: "Applied",
  [STATUS.VIEWED]: "Under Review",
  [STATUS.INTERVIEW_REQUESTED]: "Interview requested",
  [STATUS.INTERVIEW_SCHEDULED]: "Interview scheduled",
  [STATUS.OFFER]: "Offer Received",
  [STATUS.REJECTED]: "Not Selected", 
  [STATUS.HIRED]: "Hired"
} as const;